import { notifications } from '@mantine/notifications';
import { useCreateHotel } from 'api-hooks/hotel';
import { NavigationRoutes } from 'common/constants';
import { PreviousNavigation } from 'common/helpers/previous-navigation';
import useDismiss from 'hooks/use-dismiss';
import useGetCrudPermission from 'hooks/use-get-crud-permission';
import useNavigation from 'hooks/use-navigation';

import HotelForm from './components/form';

export default function HotelCreate() {
  const { navigate, back } = useNavigation();
  const createMutation = useCreateHotel();
  const permission = useGetCrudPermission('hotels');
  const onDismiss = useDismiss('hotels');

  return (
    <HotelForm
      saveMutation={createMutation}
      onSubmit={async (input) => {
        const result = await createMutation.mutateAsync(input);

        onDismiss();

        const prevPath = PreviousNavigation.get();
        if (prevPath) {
          PreviousNavigation.remove();
          back();
        } else if (permission.view) {
          navigate(NavigationRoutes.HotelsView, {
            id: result.data?.id,
          });
        }

        notifications.show({ message: result?.message, color: 'green' });

        return result.data;
      }}
    />
  );
}
